export default __webpack_public_path__ + "static/media/home_logo_list.81bb8401.jpeg";